import NoData from "assets/svgs/no_data/NoData";
import CardDiv from "modules/common/card-div/CardDiv";
import PaginationDiv from "modules/pagination/PaginationDiv";
import CreditPoints from "modules/reward_points/CreditPoints";
import UserRewardCanvas from "modules/reward_points/UserRewardCanvas";
import { useRewardsInfo } from "modules/reward_points/store";
import React, { useState, useEffect } from "react";
import { Placeholder } from "react-bootstrap";

function RewardPoints() {
  const { userListData, userLoading, fetchUserList } = useRewardsInfo();
  const [page, newPage] = useState(1);

  useEffect(() => {
    fetchUserList(page);
  }, [page]);

  const header = ["Name", "Phone Number", "Email Id"];

  return (
    <div>
      <CardDiv
        title={<div className="fs-2">Rewards Points</div>}
        component={
          <div>
            <div>
              <CreditPoints />
            </div>
            <div>
              <div
                className="mt-4 shadow rounded mt-2 scrollable-container"
                style={{ maxHeight: "70vh", overflowY: "scroll" }}
              >
                <div
                  className="d-flex table-head rounded-top"
                  style={{ position: "sticky", top: "0", zIndex: "1" }}
                >
                  {header?.map((headData) => {
                    return (
                      <span className="p-3 py-4 fw-bold text-black flex-1 border-end">
                        {headData}
                      </span>
                    );
                  })}
                </div>
                {userLoading ? (
                  <>
                    <Placeholder as="p" animation="glow">
                      <Placeholder xs={12} />
                    </Placeholder>
                    <Placeholder as="p" animation="glow">
                      <Placeholder xs={12} />
                    </Placeholder>
                    <Placeholder as="p" animation="glow">
                      <Placeholder xs={12} />
                    </Placeholder>
                    <Placeholder as="p" animation="glow">
                      <Placeholder xs={12} />
                    </Placeholder>
                    <Placeholder as="p" animation="glow">
                      <Placeholder xs={12} />
                    </Placeholder>
                  </>
                ) : userListData && userListData?.data?.userRecord?.length ? (
                  userListData?.data?.userRecord?.map((user, userIndex) => {
                    return (
                      <div
                        className={`d-flex table-row border-1 border-top-0 ${
                          userIndex === userListData?.data?.record?.length - 1 &&
                          `rounded-bottom`
                        }`}
                        key={userListData?.data?.userRecord?.user?.userId}
                      >
                        <span className="p-3 flex-1 text-break fw-bold cursor-pointer text-wrap border-end text-primary">
                          <UserRewardCanvas
                            userId={user?.userId}
                            userName={user?.name}
                          />
                        </span>
                        <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                          {user?.phoneNumber}
                        </span>
                        <span className="p-3 d-flex gap-4 flex-1 text-break text-black text-wrap border-end">
                          {user?.emailId};
                        </span>
                      </div>
                    );
                  })
                ) : (
                  <div className="p-3 bg-white rounded-bottom text-center">
                    No Data Available <NoData />
                  </div>
                )}
              </div>
            </div>
            <PaginationDiv
              paginationData={{
                pageCount:
                  Math.ceil(userListData?.data?.pagination?.totalCount / 10) ||
                  1,
                page: page,
              }}
              newPage={newPage}
            />
          </div>
        }
      />
    </div>
  );
}

export default RewardPoints;
